import { render, staticRenderFns } from "./web.vue?vue&type=template&id=545d5d8e&scoped=true&"
import script from "./web.vue?vue&type=script&lang=js&"
export * from "./web.vue?vue&type=script&lang=js&"
import style0 from "./web.vue?vue&type=style&index=0&id=545d5d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d5d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('545d5d8e', component.options)
    } else {
      api.reload('545d5d8e', component.options)
    }
    module.hot.accept("./web.vue?vue&type=template&id=545d5d8e&scoped=true&", function () {
      api.rerender('545d5d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\survey\\web.vue"
export default component.exports